(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[196],{

/***/ 35106:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[slug]",
      function () {
        return __webpack_require__(33123);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "config": function() { return /* binding */ config; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/amp.js
var amp = __webpack_require__(69135);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./src/app/components/experts/SimpleExpertLinkCard.tsx
var SimpleExpertLinkCard = __webpack_require__(18270);
;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/assert.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return encodeURIComponent(key) + "=" + encodeURIComponent(String(value));
    });
    return params.length > 0 ? "?" + params.join('&') : '';
}

// EXTERNAL MODULE: ./node_modules/react-share/node_modules/classnames/index.js
var classnames = __webpack_require__(97567);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var ShareButton_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height,
        width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return key + "=" + config[key]; })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    ShareButton_extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-" + networkName;
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    assert(url, 'twitter.url');
    assert(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    assert(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        objectToGetParams({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = hocs_createShareButton('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/LinkedinShareButton.js



function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    assert(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}
var LinkedinShareButton = hocs_createShareButton('linkedin', linkedinLink, function (_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return ({ title: title, summary: summary, source: source });
}, {
    windowWidth: 750,
    windowHeight: 600,
});
/* harmony default export */ var es_LinkedinShareButton = (LinkedinShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/EmailShareButton.js


function emailLink(url, _a) {
    var subject = _a.subject, body = _a.body, separator = _a.separator;
    return 'mailto:' + objectToGetParams({ subject: subject, body: body ? body + separator + url : url });
}
var EmailShareButton = hocs_createShareButton('email', emailLink, function (props) { return ({
    subject: props.subject,
    body: props.body,
    separator: props.separator || ' ',
}); }, {
    openShareDialogOnClick: false,
    onClick: function (_, link) {
        window.location.href = link;
    },
});
/* harmony default export */ var es_EmailShareButton = (EmailShareButton);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(94184);
var node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
;// CONCATENATED MODULE: ./src/app/components/socials/SocialShareLinks.tsx




var SocialShareLinks = function(props) {
    var isAmp = props.isAmp, shareUrl = props.url, className = props.className, classes = node_modules_classnames_default()("social-share-links-comp", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "",
                children: isAmp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("amp-social-share", {
                    type: "facebook",
                    width: "40",
                    height: "40",
                    "data-param-url": shareUrl,
                    "aria-label": "Share on Facebook"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookShareButton, {
                    className: "social-link",
                    url: shareUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fab fa-facebook-f"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "",
                children: isAmp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("amp-social-share", {
                    type: "twitter",
                    width: "40",
                    height: "40",
                    "data-param-url": shareUrl,
                    "aria-label": "Share on Twitter"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_TwitterShareButton, {
                    className: "social-link",
                    url: shareUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fab fa-twitter"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "",
                children: isAmp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("amp-social-share", {
                    type: "linkedin",
                    width: "40",
                    height: "40",
                    "data-param-url": shareUrl,
                    "aria-label": "Share on LinkedIn"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_LinkedinShareButton, {
                    className: "social-link",
                    url: shareUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fab fa-linkedin-in"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "",
                children: isAmp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("amp-social-share", {
                    type: "email",
                    width: "40",
                    height: "40",
                    "data-param-url": shareUrl,
                    "aria-label": "Share on Email"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_EmailShareButton, {
                    className: "social-link",
                    url: shareUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa fa-envelope"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var socials_SocialShareLinks = (SocialShareLinks);

;// CONCATENATED MODULE: ./src/app/utilities/routes.ts
var BreadcrumbsMapper = {
    blogs: {
        href: "/blogs"
    },
    services: {
        href: "/services"
    },
    teams: {
        href: "/teams"
    }
};

;// CONCATENATED MODULE: ./src/app/components/navs/Breadcrumbs.tsx




var convertBreadcrumb = function(string) {
    return string.replace(/[^a-zA-Z0-9,.!@#$%^&*()?]+/g, " ").toLowerCase();
};
var Breadcrumbs = function(props) {
    var isAmp = props.isAmp, uri = props.uri;
    var linkPath = (uri || "").replace(/(\?|#).+$/, "").split("/").filter(Boolean);
    var pathArray = linkPath.map(function(path, idx) {
        var result = {
            breadcrumb: path,
            href: "/"
        };
        if (idx === 0) {
            var ref;
            var href = ((ref = BreadcrumbsMapper[path]) === null || ref === void 0 ? void 0 : ref.href) || path;
            result.href = href;
        } else {
            result.href = "/" + linkPath.slice(0, idx + 1).join("/");
        }
        return result;
    });
    if (!pathArray) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "breadcrumbs-comp",
        "aria-label": "breadcrumbs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            className: "breadcrumb",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "breadcrumb-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa fa-home"
                            })
                        })
                    })
                }),
                pathArray.map(function(breadcrumb) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "breadcrumb-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: breadcrumb.href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: convertBreadcrumb(breadcrumb.breadcrumb)
                            })
                        })
                    }, breadcrumb.href);
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/app/hooks/WithUpdateCmsVisit.tsx
var WithUpdateCmsVisit = __webpack_require__(13325);
;// CONCATENATED MODULE: ./pages/blogs/[slug].tsx












var BlogPostPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var blogPost = props.blogPost, isAmp = (0,amp.useAmp)(), pageUri = "/blogs/" + blogPost.slug, title = blogPost.title, blogMetaDescription = (0,helpers/* sliceMetaDescription */.rJ)(blogPost === null || blogPost === void 0 ? void 0 : (ref = blogPost.content) === null || ref === void 0 ? void 0 : ref.text);
    /**
   * Meta contents
   */ var metaTitle = constants/* META_TITLE */.k5 || "", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = constants/* META_URL */.f1 || "", metaOgImg = constants/* META_URL */.f1 + "/logo.png", metaTwitterImg = constants/* META_URL */.f1 + "/logo.png";
    if (blogPost) {
        var ref8, ref9;
        metaTitle = "".concat(blogPost.title, " | Heritage Counseling");
        metaDescription = blogMetaDescription || metaDescription;
        metaUrl = "".concat(constants/* META_URL */.f1, "/blogs/").concat(blogPost.slug);
        metaOgImg = ((ref8 = blogPost.featuredImage) === null || ref8 === void 0 ? void 0 : ref8.url) || metaOgImg;
        metaTwitterImg = ((ref9 = blogPost.featuredImage) === null || ref9 === void 0 ? void 0 : ref9.url) || metaTwitterImg;
    }
    // Override metas using pageMeta
    var pageMeta = (blogPost === null || blogPost === void 0 ? void 0 : blogPost.meta) || {};
    if (Object.keys(pageMeta).length > 0) {
        var ref10, ref11;
        metaTitle = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.title) || metaTitle;
        metaDescription = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.description) || metaDescription;
        metaOgImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref10 = pageMeta.ogImage) === null || ref10 === void 0 ? void 0 : ref10.url) || metaOgImg;
        metaTwitterImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref11 = pageMeta.twitterImage) === null || ref11 === void 0 ? void 0 : ref11.url) || metaTwitterImg;
    }
    return isAmp && blogPost ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "blog-post-page",
        "data-testid": "blog-post-page-amp",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaOgImg
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaTwitterImg
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "wrapper",
                itemScope: true,
                itemType: "https://schema.org/Article",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "wordcount",
                        content: blogPost.schema.wordcount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "image",
                        content: blogPost.schema.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "datePublished",
                        content: blogPost.schema.datePublished
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "dateCreated",
                        content: blogPost.schema.dateCreated
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "dateModified",
                        content: blogPost.schema.dateModified
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blog-body",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {
                                uri: pageUri,
                                isAmp: isAmp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                itemProp: "headline",
                                children: blogPost.title
                            }),
                            !!((ref1 = blogPost.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "img-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("amp-img", {
                                    alt: blogPost.title,
                                    src: (ref2 = blogPost.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.url,
                                    width: (ref3 = blogPost.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.width,
                                    height: (ref4 = blogPost.featuredImage) === null || ref4 === void 0 ? void 0 : ref4.height,
                                    layout: "responsive"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blog-content cms-content",
                                itemProp: "articleBody",
                                dangerouslySetInnerHTML: {
                                    __html: blogPost.content.html
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blog-side",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(socials_SocialShareLinks, {
                                url: metaUrl,
                                isAmp: isAmp
                            }),
                            (blogPost === null || blogPost === void 0 ? void 0 : blogPost.author) && (blogPost === null || blogPost === void 0 ? void 0 : (ref5 = blogPost.author) === null || ref5 === void 0 ? void 0 : ref5.firstName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "author",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        children: " Author "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleExpertLinkCard/* default */.Z, {
                                        expert: blogPost.author,
                                        isAmp: isAmp
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: title,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaOgImg
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaTwitterImg
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "amphtml",
                        href: metaUrl + "?amp=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    }),
                    (blogPost === null || blogPost === void 0 ? void 0 : blogPost.schema) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(blogPost.schema)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "blog-post-page",
                "data-testid": "blog-post-page",
                children: [
                    blogPost ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-body",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {
                                        uri: pageUri,
                                        isAmp: isAmp
                                    }),
                                    !!((ref6 = blogPost.featuredImage) === null || ref6 === void 0 ? void 0 : ref6.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "img-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "featured-img",
                                            src: (ref7 = blogPost.featuredImage) === null || ref7 === void 0 ? void 0 : ref7.src,
                                            alt: blogPost.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "blog-content cms-content",
                                        dangerouslySetInnerHTML: {
                                            __html: blogPost.content.html
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-side",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(socials_SocialShareLinks, {
                                        url: metaUrl,
                                        isAmp: isAmp
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "author",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: " Author "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleExpertLinkCard/* default */.Z, {
                                                expert: blogPost.author
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: "No blog found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "mt-5 mt-lg-10",
                        role: "navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "link-back",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-angle-left"
                                    }),
                                    "Back to Home"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
var config = {
    amp: "hybrid"
};
/* harmony default export */ var _slug_ = ((0,WithUpdateCmsVisit/* withUpdateCmsVisit */.D)(BlogPostPage));


/***/ }),

/***/ 18270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);




var SimpleExpertLinkCard = function(props) {
    var ref, ref1, ref2;
    var expert = props.expert, isAmp = props.isAmp, className = props.className, classes = classnames__WEBPACK_IMPORTED_MODULE_3___default()("simple-expert-link-card", className), displayName = [
        expert.firstName || "",
        expert.lastName || ""
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/teams/".concat(expert.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: classes,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "img-container",
                    children: isAmp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("amp-img", {
                        alt: expert.slug,
                        src: (ref = expert.image) === null || ref === void 0 ? void 0 : ref.src,
                        width: 150,
                        height: 150,
                        layout: "responsive"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "avatar",
                        src: ((ref1 = expert.image) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                        loading: "lazy",
                        width: 300,
                        height: 311,
                        alt: expert.slug
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "display-name",
                    children: [
                        displayName,
                        ((ref2 = expert.credentials) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "d-none d-md-inline",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: ",\xa0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "credentials",
                                    children: expert.credentials.join(", ")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                }),
                expert.position ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "position",
                    children: expert.position
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleExpertLinkCard);


/***/ }),

/***/ 75019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_PageLayoutV1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/static/images/layout/layout-hero-1440.jpg
/* harmony default export */ var layout_hero_1440 = ({"src":"/_next/static/media/layout-hero-1440.020fe420.jpg","height":318,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIFElFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCRLWMQhZDbvjERJi//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/app/hocs/PageLayoutV1.tsx






var PageLayoutV1 = function(param) {
    var title = param.title, tagline = param.tagline, children = param.children, fluidContainer = param.fluidContainer, noPadding = param.noPadding;
    var isContainerFluid = (0,helpers/* isNullOrUndefined */.le)(fluidContainer) ? false : fluidContainer, containerClasses = classnames_default()("layout-container", {
        container: !isContainerFluid,
        "no-padding": !!noPadding
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-v1",
        "data-testid": "layout-v1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: layout_hero_1440.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title || "Heritage Consulting"
                        }),
                        tagline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tagline",
                            children: tagline
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClasses,
                children: children
            })
        ]
    });
};
/* harmony default export */ var hocs_PageLayoutV1 = (PageLayoutV1);


/***/ }),

/***/ 13325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ withUpdateCmsVisit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _app_utilities_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46613);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50196);









var withUpdateCmsVisit = function(PageComponent) {
    var WithUpdateCmsVisit = function(_param) {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _param);
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), pageUri = router.asPath.replace(/\?.*$/i, "");
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            // Increment visits
            if (typeof navigator !== "undefined" && _app_utilities_constants__WEBPACK_IMPORTED_MODULE_2__/* .IS_PROD */ .XK) {
                var data = {
                    uri: pageUri
                };
                axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("/api/analytics", {
                    params: data
                });
            }
        }, []);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
    };
    if (PageComponent.getInitialProps) {
        WithUpdateCmsVisit.getInitialProps = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(appCtx) {
                var pageProps;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                PageComponent.getInitialProps ? PageComponent.getInitialProps(appCtx) : {}
                            ];
                        case 1:
                            pageProps = _state.sent();
                            return [
                                2,
                                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, pageProps)
                            ];
                    }
                });
            });
            return function(appCtx) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    return WithUpdateCmsVisit;
};


/***/ }),

/***/ 97567:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(35106); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);